// Thrown by the response handlers for any non-2xx RPC response. Carries the
// HTTP status so retry logic can tell a verdict (4xx — retrying repeats the
// same refusal) from a hiccup (5xx or network — worth retrying). Lives here
// rather than in a UI package so web and native share one class identity for
// instanceof checks.
export class ResponseError extends Error {
	readonly status: number;
	/**
	 * The body's `code`, where it carried one — the class of refusal (`conflict`, `forbidden`),
	 * shared by every error the middleware answers with that status.
	 */
	readonly code: string | null;
	/**
	 * The body's `message` **before** it was localised, which is the i18n key naming the one
	 * refusal this is. `message` is the rendered German or English sentence and cannot be compared
	 * against, so a caller that has to tell `stock.wrong_warehouse_zone` from any other conflict
	 * reads this. Null when the body carried no `code`, since then `message` was never a key.
	 */
	readonly key: string | null;

	constructor(
		message: string,
		status: number,
		options?: { code?: string | null; key?: string | null },
	) {
		super(message);
		this.name = "ResponseError";
		this.status = status;
		this.code = options?.code ?? null;
		this.key = options?.key ?? null;
	}
}
